interface FlipCardProps {
    front: React.ReactNode
    back: React.ReactNode
    turns: number
}

export function FlipCard({ front, back, turns }: FlipCardProps) {
    const isFrontVisible = turns % 2 === 0
    return (
        <div className='w-full h-full' style={{ perspective: 1000 }}>
            <div
                className='relative w-full h-full'
                style={{
                    transition: 'transform 0.6s ease-in-out',
                    transformStyle: 'preserve-3d',
                    transform: `rotateY(${turns * 180}deg)`,
                }}
            >
                <div
                    className='absolute inset-0'
                    style={{ backfaceVisibility: 'hidden', pointerEvents: isFrontVisible ? 'auto' : 'none' }}
                >
                    {front}
                </div>
                <div
                    className='absolute inset-0'
                    style={{
                        backfaceVisibility: 'hidden',
                        transform: 'rotateY(180deg)',
                        pointerEvents: !isFrontVisible ? 'auto' : 'none',
                    }}
                >
                    {back}
                </div>
            </div>
        </div>
    )
}
